import React from "react";

export default function ProjectManagement() {
  return (
    <svg
      width="480"
      height="480"
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ProjectManagement">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M223.887 230.688L207.999 135.344V8C207.999 3.582 204.417 0 199.999 0H23.9989C19.5809 0 15.9989 3.582 15.9989 8V135.344L0.110888 230.688C-0.614112 235.046 2.33189 239.167 6.69089 239.892C7.12289 239.964 7.55989 240 7.99889 240H215.999C220.417 239.998 223.997 236.415 223.995 231.996C223.995 231.558 223.959 231.12 223.887 230.688ZM31.9989 16H191.999V128H31.9989V16V16ZM17.4469 224L30.7749 144H193.223L206.551 224H17.4469Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M55.999 160H39.999V176H55.999V160Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_3"
              d="M55.999 192H39.999V208H55.999V192Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_7">
          <g id="Group_8">
            <path
              id="Vector_4"
              d="M151.999 192H71.999V208H151.999V192Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_9">
          <g id="Group_10">
            <path
              id="Vector_5"
              d="M183.999 192H167.999V208H183.999V192Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_11">
          <g id="Group_12">
            <path
              id="Vector_6"
              d="M87.999 160H71.999V176H87.999V160Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_13">
          <g id="Group_14">
            <path
              id="Vector_7"
              d="M119.999 160H103.999V176H119.999V160Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_15">
          <g id="Group_16">
            <path
              id="Vector_8"
              d="M151.999 160H135.999V176H151.999V160Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_17">
          <g id="Group_18">
            <path
              id="Vector_9"
              d="M183.999 160H167.999V176H183.999V160Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_19">
          <g id="Group_20">
            <path
              id="Vector_10"
              d="M64.143 32C55.231 32.009 48.008 39.232 47.999 48.144V72H63.999L64.143 48H95.999V32H64.143Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_21">
          <g id="Group_22">
            <path
              id="Vector_11"
              d="M127.999 32H111.999V48H127.999V32Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_23">
          <g id="Group_24">
            <path
              id="Vector_12"
              d="M288.143 304C279.231 304.009 272.008 311.232 271.999 320.144V344H287.999L288.143 320H319.999V304H288.143Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_25">
          <g id="Group_26">
            <path
              id="Vector_13"
              d="M351.999 304H335.999V320H351.999V304Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_27">
          <g id="Group_28">
            <path
              id="Vector_14"
              d="M471.999 272H247.999C243.581 272 239.999 275.582 239.999 280V432C239.999 436.418 243.581 440 247.999 440H326.239L321.439 464H303.999V480H415.999V464H398.559L393.759 440H471.999C476.417 440 479.999 436.418 479.999 432V280C479.999 275.582 476.417 272 471.999 272ZM337.759 464L342.559 440H377.439L382.239 464H337.759ZM463.999 424H255.999V408H463.999V424ZM463.999 392H255.999V288H463.999V392Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_29">
          <g id="Group_30">
            <path
              id="Vector_15"
              d="M210.199 380.92L206.919 396.576C212.383 397.721 217.902 398.584 223.455 399.16L225.095 383.232C220.093 382.722 215.12 381.95 210.199 380.92Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_31">
          <g id="Group_32">
            <path
              id="Vector_16"
              d="M181.591 371.672L175.095 386.296C180.199 388.56 185.42 390.552 190.735 392.264L195.655 377.064C190.876 375.514 186.181 373.714 181.591 371.672Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_33">
          <g id="Group_34">
            <path
              id="Vector_17"
              d="M155.511 356.624L146.127 369.6C150.647 372.87 155.333 375.903 160.167 378.688L168.167 364.832C163.81 362.315 159.586 359.575 155.511 356.624Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_35">
          <g id="Group_36">
            <path
              id="Vector_18"
              d="M133.127 336.504L121.263 347.24C125.005 351.378 128.957 355.322 133.103 359.056L143.807 347.152C140.063 343.791 136.499 340.237 133.127 336.504Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_37">
          <g id="Group_38">
            <path
              id="Vector_19"
              d="M115.399 312.176L101.551 320.176C104.355 325.002 107.41 329.678 110.703 334.184L123.623 324.8C120.662 320.739 117.917 316.525 115.399 312.176Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_39">
          <g id="Group_40">
            <path
              id="Vector_20"
              d="M103.087 284.744L87.887 289.744C89.631 295.043 91.644 300.25 93.919 305.344L108.519 298.816C106.468 294.221 104.655 289.525 103.087 284.744Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_41">
          <g id="Group_42">
            <path
              id="Vector_21"
              d="M96.767 255.376L80.887 257.032C81.474 262.597 82.352 268.127 83.519 273.6L99.167 270.24C98.105 265.331 97.304 260.37 96.767 255.376Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_43">
          <g id="Group_44">
            <path
              id="Vector_22"
              d="M383.999 240C383.992 245.029 383.725 250.054 383.199 255.056L399.127 256.696C399.701 251.149 399.992 245.577 399.999 240V239.376L383.999 240Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_45">
          <g id="Group_46">
            <path
              id="Vector_23"
              d="M396.399 206.12L380.759 209.496C381.818 214.403 382.619 219.361 383.159 224.352L399.063 222.648C398.468 217.095 397.578 211.578 396.399 206.12Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_47">
          <g id="Group_48">
            <path
              id="Vector_24"
              d="M385.927 174.352L371.351 180.928C373.41 185.512 375.234 190.198 376.815 194.968L391.999 189.952C390.247 184.65 388.22 179.443 385.927 174.352Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_49">
          <g id="Group_50">
            <path
              id="Vector_25"
              d="M369.103 145.48L356.207 154.944C359.178 158.995 361.936 163.198 364.471 167.536L378.295 159.48C375.482 154.653 372.413 149.98 369.103 145.48Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_51">
          <g id="Group_52">
            <path
              id="Vector_26"
              d="M346.671 120.736L335.999 132.656C339.747 136.014 343.322 139.56 346.711 143.28L358.535 132.512C354.784 128.386 350.824 124.456 346.671 120.736Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_53">
          <g id="Group_54">
            <path
              id="Vector_27"
              d="M319.543 101.152L311.543 115.024C315.919 117.532 320.165 120.26 324.263 123.2L333.599 110.216C329.073 106.954 324.382 103.929 319.543 101.152Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_55">
          <g id="Group_56">
            <path
              id="Vector_28"
              d="M288.951 87.6318L284.063 102.832C288.846 104.386 293.546 106.185 298.143 108.224L304.607 93.5838C299.493 91.3338 294.268 89.3468 288.951 87.6318Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_57">
          <g id="Group_58">
            <path
              id="Vector_29"
              d="M256.215 80.8076L254.615 96.7276C259.615 97.2286 264.584 97.9956 269.503 99.0236L272.759 83.3516C267.292 82.2186 261.77 81.3696 256.215 80.8076Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_59">
          <g id="Group_60">
            <path
              id="Vector_30"
              d="M239.511 80C233.936 80.017 228.366 80.321 222.823 80.912L224.503 96.824C229.505 96.299 234.53 96.032 239.559 96.024L239.511 80Z"
              fill="#242424"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
